<template>
  <Navigation />
  <Header 
    :title="currentRoute.title"
    :subtitle="currentRoute.subtitle"
  />
  <router-view></router-view>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import Header from '@/components/HeaderComponent.vue'

export default {
  name: 'App',
  components: {
    Navigation,
    Header
  },
  data() {
    return {
      routes: {
        home: {
          title: 'Grace Baptist Church Walkerville',
          subtitle: 'Welcome to our church family in Walkerville'
        },
        beliefs: {
          title: 'What We Believe',
          subtitle: 'Our Statement of Faith and Baptist Distinctives'
        }
      }
    }
  },
  computed: {
    currentRoute() {
      const path = this.$route.path
      if (path === '/beliefs') {
        return this.routes.beliefs
      }
      return this.routes.home
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
